import Link from "next/link";

import { TypoGraph } from "@/components/ui/primitives";

const SideBarItem = ({
  href,
  label,
  isActive,
  notificationCount,
}: {
  href: string;
  label: string;
  isActive: boolean;
  notificationCount?: number;
}) => {
  return (
    <Link href={href}>
      <div
        className={`flex justify-between items-center w-[180px] px-6 py-3 h-12 rounded-lg cursor-pointer transition-colors duration-300 ${
          isActive ? "bg-primary-800" : "bg-transparent hover:bg-primary-800"
        }`}
      >
        <TypoGraph variant={isActive ? "body01" : "body02"} className="text-gray-500">
          {label}
        </TypoGraph>
        {(notificationCount ?? 0) > 0 && (
          <div className="flex justify-center items-center rounded-full px-2 py-1 h-6 w-[38px] bg-danger-400">
            <TypoGraph variant="label05" color="white">
              {notificationCount}
            </TypoGraph>
          </div>
        )}
      </div>
    </Link>
  );
};

export default SideBarItem;
